/**
 * Invoice line item types, matching the backing values of
 * App\Libs\Billing\Enums\InvoiceItemType.
 */
const INVOICE_ITEM_TYPE = {
  SUBSCRIPTION: 1,
  OVERAGE: 2,
  ADD_ON: 3,
  ONE_TIME: 4,
  PRORATION: 5,
  DOMAIN_PURCHASE: 6,
  DOMAIN_RENEWAL: 7,
};

export default INVOICE_ITEM_TYPE;
